import { IS_REDUX_LOGGER_ENABLED } from '@libs/utils/environments'
import { createLogger } from 'redux-logger'

export const logger = IS_REDUX_LOGGER_ENABLED
  ? createLogger({
      collapsed: true
    })
  : undefined
